import React from "react";
import "../../../css/NuestraCiudad/historia.css";

const Historia = () => (
  <div className="historia-bg">
    <div className="historia-container">
      <h1 className="historia-title">HISTORIA</h1>
      <div className="historia-desc">
        <a
          href="https://ciudaddeoliva.gob.ar/wp-content/uploads/2022/02/Historia-Ciudad-de-Oliva.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="historia-pdf-link"
        >
          Haga click aquí para Descargar PDF
        </a>
      </div>

      {/* Historia inicial */}
      <div className="historia-section">
        <img
          src="https://i.imgur.com/j2Kc1Ln.png"
          alt="Historia Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            Transcurriendo el último cuarto del siglo XIX, las carretas
            provenientes de Buenos Aires en su viaje al Norte, hacían un alto en
            una pequeña isleta de algarrobos a la altura de Corral de Pachi,
            paraje ubicado media legua más al norte del lugar en donde algunos
            ranchos dispersos señalaban el principio de lo que más tarde sería
            un pueblo. La Cía. de Tierras Anglo-Argentina avanzaba en el tendido
            del Ferrocarril Central Argentino en el tramo Rosario-Córdoba,
            cruzando la zona antes mencionada a cuya vera nacieron un sinfín de
            localidades.
          </p>
          <p>
            El gentilicio se agrupó y un gran hormiguero prestó su nombre a la
            incipiente aldea señalando así el comienzo de la futura ciudad. Los
            primeros colonos en su gran mayoría eran inmigrantes de origen
            Español, Italiano, Suizos y Franceses. Antes de la llegada de los
            mismos, la densidad de la población en esta región, era muy baja y
            con zonas prácticamente desiertas.
          </p>
          <p>
            Los inmigrantes trajeron su forma de vida y conforme a estos
            patrones desplegaron sus actividades constituyendo una comunidad de
            gran espíritu de empresa, con capacidad de trabajo, voluntad de
            cambio e imaginación para resolver sus problemas.
          </p>
        </div>
      </div>

      <div className="historia-section">
        <img
          src={require("../../img/bNbbjzb.png")}
          alt="Historia Oliva"
          className="historia-img-right"
        />
        <div>
          <p>
            La idea de obtener un lugar en el mundo, los impulsaba a luchar y la
            tierra era su principal recurso. La agricultura y un incipiente
            comercio constituían la base de su economía.
          </p>
          <p>
            El desarraigo y la incertidumbre motivaron a los pobladores a
            estrechar vínculos afectivos, haciendo de la colonia una comunidad
            familiar. Hacia 1888, los Sres. Crisólogo Oliva y Santiago Díaz,
            adquirieron grandes porciones de terreno que luego lotearon y
            vendieron a muy bajos precios con la condición de que en ellos se
            construyeran viviendas. Así, el rancherío comenzó a entremezclarse
            con elementales negocios que cubrían las necesidades más
            fundamentales.
          </p>
          <p>
            El 10 de noviembre de 1890, quedó inaugurada y habilitada al
            público, la Estación de Trenes con el nombre de Oliva, en homenaje a
            uno de sus precursores. En el mismo año, el Gobernador de Córdoba,
            Del Castillo, creó una Comisión Vecinal que fue el primer gobierno
            organizado de la aldea.
          </p>
        </div>
      </div>

      <div className="historia-section">
        <div>
          <p>
            En 1900, dicha Comisión Vecinal es elevada a la categoría de
            Comisión Municipal. A partir de entonces se sucedieron hechos
            referentes a la caracterización institucional: creación del Registro
            Civil, del Servicio de recolección de residuos, inauguración del
            edificio de la Jefatura de Policía con el nombre de Cabildo, tras lo
            que Oliva pasa a ser cabecera del Departamento Tercero Arriba, e
            inauguración de la Parroquia Sagrado Corazón.
          </p>
          <p>
            En 1908, se iniciaron estudios a los fines de establecer la aptitud
            de la zona para asentamiento de una Colonia Asilo Regional Mixta de
            Alienados, construcción que se concretó e inauguró el 4 de julio de
            1914, hoy Hospital Dr. Emilio Vidal Abal.
          </p>
          <p>
            Los años subsiguientes dotaron a Oliva del primer servicio eléctrico
            (1916), se realizaron los primeros comicios para elegir intendente y
            concejales (1920), se inauguró el Hospital zonal y el Edificio
            Municipal (1927) y el segundo elevador de granos del país (1930).
          </p>
        </div>
      </div>

      {/* Línea de tiempo */}
      <div className="historia-timeline">
        <h2>Línea de tiempo en Oliva</h2>
        <ul>
          <li>
            1880-1890. El ferrocarril cruza por la zona. Empieza el primer
            esbozo del pueblo
          </li>
          <li>
            1888. Crisólogo Oliva y Santiago Díaz lotean y venden a muy bajo
            precio terrenos adyacentes al ferrocarril. El rancherío se agrupa,
            elementales negocios cubren las necesidades indispensables.
          </li>
          <li>
            1890. El Gobernador de Córdoba, D. del Castillo crea una Comisión
            Vecinal, siendo éste el primer gobierno organizado de la aldea,
            Crisólogo Oliva y Santiago Díaz donan el terreno para la
            construcción de la estación de cargas y pasajeros al FF. CC.
          </li>
          <li>
            1893. Se habilita al público la estación de FF. CC. Con el nombre de
            OLIVA, en homenaje del benefactor; Don Crisólogo Oliva, quedando así
            reemplazado el nombre de “Los Hormigueros”, con que se conocía hasta
            entonces a la población.
          </li>
          <li>1897. Primer Escuela inaugurada, Escuela Bartolomé Mitre.</li>
          <li>
            1900. La Comisión Vecinal es elevada a la categoría de Comisión
            Municipal.
          </li>
          <li>1902. Se crea el Registro Civil.</li>
          <li>1907. Primer servicio de recolección de residuos</li>
          <li>
            1909. Se inaugura con el nombre de Cabildo el edificio de la
            Jefatura, pasando Oliva a ser cabeza del Depto. Tercero Arriba. Se
            incorpora el riego de las calles y alumbrado público a gas.
          </li>
          <li>1912. Se inaugura la Parroquia Sagrado Corazón.</li>
          <li>1914. Inauguración del Hospital Dr. Emilio Vidal Abal.</li>
          <li>
            1916. Se concreta el primer servicio eléctrico para Oliva. Abre sus
            puertas el Banco Nación Argentina.
          </li>
          <li>
            1920. Se realizan por primera vez, comicios para elegir intendente y
            concejales. Es consagrado primer Intendente el Sr. Juan Chiappero.
          </li>
          <li>1921. Fundación del Independiente Deportivo Social Club</li>
          <li>1927. Se inaugura el hospital y el edificio Municipal</li>
          <li>1928. El HCD aprueba el diseño del Escudo Oficial de Oliva.</li>
          <li>1930. Se inaugura el segundo elevador de granos del país.</li>
          <li>1935. Cruza por Oliva la ruta asfaltada Nacional Nº 9</li>
          <li>1936. Fundación del Club Atlético Vélez Sarsfield Oliva.</li>
          <li>
            1953. Fundación de la Cooperativa de Obras y Servicios públicos.
          </li>
          <li>1962. Primer Fiesta de la Navidad Gaucha.</li>
          <li>
            1964. Por decreto del Superior Gobierno de la Pcia, Oliva es elevada
            a la categoría de ciudad.
          </li>
          <li>1972. Fundación del Aeroclub Oliva.</li>
          <li>
            1973. Fundación del Cuerpo de Bomberos Voluntarios de Oliva. Nace la
            Agrupación Gaucha José Hernández.
          </li>
          <li>
            1982. Se inaugura la Terminal de Ómnibus y el Edificio Telecom.
          </li>
          <li>1985. Se inaugura la Red de Gas Natural.</li>
          <li>
            1986. Centenario de la ciudad de Oliva. Fundación del Movimiento
            Cultura Región del Manco Paz.
          </li>
          <li>1989. Se inaugura el Edificio de Correo Argentino.</li>
          <li>1993. Se inaugura Tribunales de Oliva. Creación de la APAO.</li>
          <li>1995. Creación del Museo Nacional de Malvinas.</li>
          <li>1999. Inauguran la Capilla San Cayetano.</li>
          <li>2003. Comienzan a funcionar los servicios de internet.</li>
          <li>
            2004. Construcción del Edificio de Escuela Especial Rosa S. Nocetti.
          </li>
          <li>
            2009. Contratación y finalización del “Paseo Milton Pablo Galindez”.
          </li>
          <li>2010. Inauguración del Centro Cívico.</li>
          <li>2010. Creación de la Bandera y del Himno de la ciudad.</li>
          <li>
            2012. Primera Edición de la Fiesta Nacional de la Navidad Gaucha.
          </li>
          <li>2013. Inauguración de la Planta de elaboración de hormigón.</li>
          <li>2014. Creación del Plan Mi Hogar.</li>
          <li>2015. Hermanamiento con San Pietro Val Lemina, Italia.</li>
          <li>2016. Inauguración del IPET Nº 143 “Gral. José María Paz”.</li>
          <li>
            2017. Puesta en valor de la Plaza del Bicentenario de la
            Independencia.
          </li>
          <li>
            2019. Inauguración de Jardín Maternal “Medalla Milagrosa” y Edificio
            del Concejo Deliberante de la ciudad.
          </li>
          <li>
            2020. Aprobación de la Carta Orgánica Municipal. Celebración del Día
            de la Autonomía Municipal.
          </li>
        </ul>
        <div className="contImgLineaTiempo">
          <img
            src="https://i.imgur.com/g9M9bWC.png"
            alt="Linea de tiempo Oliva"
            className="historia-img-center"
          />
          <img
            src="https://i.imgur.com/bYbOogo.png"
            alt="Linea de tiempo Oliva"
            className="historia-img-center"
          />
        </div>
      </div>

      {/* Hospital Dr. Emilio Vidal Abal */}
      <div className="historia-section">
        <h2 className="historia-subtitle">Hospital Dr. Emilio Vidal Abal</h2>
        <p>
          El Asilo Colonial Regional Mixto de Alienados fue proyectado, planeado
          y ejecutado por la Comisión Asesora de Asilos y Hospitales Regionales,
          presidida por el maestro Doctor Domingo Cabred, con el fin de dar
          cumplimiento a la Ley de Previsión y Asistencia Social Nº 4953,
          promulgada el 28 de julio de 1906.
        </p>
        <img
          src={require("../../img/J7pkzN5.png")}
          alt="Hospital Emilio Vidal Abal"
          className="historia-img-left"
        />
        <p>
          La función principal de dicho proyecto es un vasto plan de
          construcciones destinadas a la asistencia más variada: tuberculosos,
          alienados, palúdicos, alcohólicos, deficientes mentales y morales,
          leprosos y enfermos generales. Para fundar el Asilo, se trajeron
          especialistas de Europa para constatar cuál era el mejor lugar y el
          mejor clima para los pacientes alienados. La fracción de tierra
          destinada a su ubicación y funcionamiento (600 hectáreas localizadas
          en el Departamento Tercero Arriba, pedanía de “Los Zorros”, localidad
          de Oliva), fue adquirida por compra a Don Crisólogo Oliva (fundador de
          la ciudad de Oliva). La respectiva escritura de dominio se firmó en el
          mes de mayo de 1908, colocándose la piedra fundamental, en conjunto
          con la Cruz que permanecen frente a la Capilla del Asilo.
        </p>
        <p>
          Llegado de Buenos Aires (Capilla de Belgrano) de origen español, con
          la designación de Capellán de la Capilla del Hospital, arribó el
          Reverendo Padre Máximo Hernando Iglesias que durante muchos años y
          junto a las Hermanas Carmelitas asistió a los enfermos
          espiritualmente, como amigo y confidente; los domingos y fiestas
          religiosas enviaba el mensaje de Dios; ¡tanta devoción! en cada uno de
          ellos, era admirable ver en sus ojos lágrimas y oír sus cantos de
          alabanza que servían de ejemplo a todos los feligreses que compartían
          la santa misa. No se puede olvidar la fiesta de la Virgen Del Carmen,
          Patrona de la Colonia; todos los 16 de julio se realizaba el oficio
          religioso, la procesión a la que asistían los enfermos engalanados con
          ropa de calle, sombreros, alhajas llamativas, flores y después de ella
          la fiesta con bailes, golosinas; todo sonrisas, esperando la sirena
          que llamaba al reposo.
        </p>
        <img
          src={require("../../img/xjM400L.png")}
          alt="Hospital Emilio Vidal Abal"
          className="historia-img-right"
        />
        <p>
          El 4 de julio de 1914, se lo inaugura con la llegada de treinta monjas
          españolas de la orden de las Carmelitas Descalzas, y treinta pacientes
          de la Capital Federal que llegaron en tren pertenecientes a los
          manicomios de Capital Federal (Hospicio de las Mercedes con la Colonia
          de Open-Door y el Hospital Nacional de Alienados con su Colonia anexa
          de Lomas de Zamora); y así sucesivamente comenzaron a llegar enfermos
          de Capital Federal, de la Provincia de Buenos Aires, de territorios
          del Sur, y eventualmente, el aporte de todo el país. En estos tiempos
          se cambió el nombre y se lo llamó “Asilo Regional Mixto de Alienados”.
        </p>
        <p>
          En el año 1923, se realizaron obras de ampliación en la sección
          mujeres y posteriormente la habilitación de las manzanas de las Villas
          de ambas secciones, varones y mujeres. En efecto, la situación de
          hacinamiento en los manicomios metropolitanos, se solucionó
          momentáneamente con la habilitación de este Asilo. De este modo fue
          como comenzó a desarrollarse un fuerte crecimiento en infraestructura.
        </p>
        <p>
          El Asilo de Oliva, tal cual fue planeado y ejecutado, no fue producto
          de la improvisación ni ensayo, se pusieron en práctica nuevos
          principios y objetivos que eran revolucionarios para la época y que
          consistían en el Tratamiento en libertad (modo OpenDoor), resultado de
          las investigaciones de Pinel en Francia, por un lado, y el
          “Non-restrain”, adjudicado a Conolli, el cual consistía en la
          supresión de todo medio de contención mecánica, como el uso de la
          sujeción, el encierro y la vigilancia.
        </p>
      </div>

      {/* Reseña Cultural */}
      <div className="historia-section">
        <h2 className="historia-subtitle">Reseña Cultural</h2>
        <img
          src={require("../../img/dhQUlmT-150x150.png")}
          alt="Cultura Oliva"
          className="historia-img-right"
        />
        <p>
          La ciudad de Oliva se ha caracterizado desde sus inicios con un
          surtido nivel cultural, con expansión regional, provincial y hasta
          llegar a los planos nacionales e internacionales. Con entidades,
          organizaciones, movimientos y personalidades destacadas de la cultura;
          Oliva ha forjado sus cimientos que en la actualidad se encuentran
          plasmados en el incentivo de establecimientos educativos, en fechas
          festivas consolidadas tradicionalmente y de un sentido de pertenencia
          único.
        </p>
        <p>
          Si bien se han modificado las formas y los recursos para hacer conocer
          a la sociedad los bienes históricos de la ciudad al igual que los
          edificios de instituciones y sus hechos que han dado forma a una
          ciudad desde que se llamaba “Los Hormigueros”, pasando por “Estación
          Oliva” y hasta constituirse y declararse oficialmente como “Ciudad de
          Oliva”.
        </p>
        {/* Aquí puedes seguir agregando el resto de la sección cultural, imágenes y textos, siguiendo el patrón anterior */}
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/aQt7hwb.png"
          alt="Cultura Oliva"
          className="historia-img-right"
          width={150}
        />
        <div>
          <p>
            En los comienzos de esta localidad, en el año 1903, se funda la
            Asociación Italiana Giuseppe Mazzini; la institución más longeva de
            la ciudad, que colabora, participa tanto como institución como en
            una de sus brazos culturales como lo es el Coro y la Escuela de
            Lengua Italiana “Dante Alighieri“ y crece en cuanto al aporte
            cultural expandiendo el nombre de Oliva hasta Italia; más
            precisamente San Pietro Val Lemina, que desde el 2015 se estrechó el
            vínculo de ciudades hermanas con el objetivo de lograr compartir
            costumbres, visiones, talentos y mucha historia que fluye en cada
            evento realizado como concurso de muestras fotográficas o literarios
            difundiendo lo más expresivo de cada participante.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/dSvup7N.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            En 1921 se funda el Independiente Deportivo Social Club, este año es
            su año del Centenario; vislumbrando un crecimiento notable,
            desarrollando alternativas deportivas y colaborando con la comunidad
            dando espacio a la expresión corporal de sus deportistas en cada
            disciplina. Además de ello, realiza una de las festividades clásicas
            de la ciudad, como la Fiesta del Chacinado casero albergando a
            comensales de la ciudad y la zona.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/8fPGMDq.png"
          alt="Cultura Oliva"
          className="historia-img-right"
          style={{ width: "280px" }}
        />
        <div>
          <p>
            En 1928 se funda la Sociedad Española y de Socorros Mutuos, siendo
            el primer Presidente el Sr. Ramón López Álvarez. Otra de las
            instituciones más prestigiosas de la ciudad, con una gran afluencia
            de público colaborador en cada evento que se realice, participación
            social y artística destacada. Para sumarle al importante aporte a la
            comunidad, en el año 1945 se crea el Auditorio de la Sociedad
            Española para uso artístico, celebraciones públicas y centro de
            convenciones y reuniones. Este mismo año se crea y el Escudo de
            nuestra ciudad allá por 1928, por obra de Ramón Pereira; y aprobado
            por el Poder Ejecutivo a cargo del Intendente Venchiarutti,
            empezando a darle identidad&nbsp;tangible y representativa a la
            localidad.
          </p>
          <p>
            En&nbsp;1930 se inaugura la Sociedad Recreativa Cultural “Juventud
            Unida” bajo la Presidencia de Nicolás Esper. Esta entidad ha sido la
            precursora de grandes logros de manera unitaria como la creación de
            la Biblioteca Popular “Juventud Unida” y el, hoy, Colegio Secundario
            IPEM Nº 72 “Juventud Unida” o en conjunto con otras instituciones,
            en cuanto a la creación de plazas como la José Hernández en Barrio
            Medalla Milagrosa. Actualmente, transitando el 2021, la institución
            ha tomado una fortaleza similar a la de sus inicios pregonando la
            cultura y la educación, instalando en nuestra ciudad la Universidad
            Popular bajo la tutela o coordinación de la Universidad Nacional de
            Córdoba.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/SAftWXk.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            Otra de las instituciones que colaboran al crecimiento de la
            localidad, con afluencia de público y deportistas constante en todas
            las disciplinas; es el Club Atlético Vélez Sarsfield; fundado en
            1936. Esta institución celebra desde hace más de 20 años la Fiesta
            Provincial de la Amistad, con el menú característico del chacinado
            casero elaborado en el mismo club con socios y colaboradores. Una
            fiesta auténtica y muy sentida para los aficionados al pueblo
            velezano.
          </p>
          <p>
            En el año 1962, por obra y gracia de quien en esa época era el Cura
            del pueblo, Roberto Larocca, comúnmente llamado el Cura Gaucho por
            los vecinos; de un corazón enorme, querido por todo el pueblo y con
            un carisma y una creatividad impresionante. Ha sido Él, el mentor de
            la Fiesta de la Navidad Gaucha, y junto con la colaboración de
            amigos y allegados, se le dio forma a la idea de expresar el
            nacimiento del Niño Gaucho en el pesebre rodeado de tradición
            argentina, basándose en el Evangelio Criollo de Amado Anzi.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/4VS8GbD.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <img
          src="https://i.imgur.com/Q5HqCpN.png"
          alt="Cultura Oliva"
          className="historia-img-right"
        />
        <div>
          <p>
            Desde sus orígenes, la historia de Oliva se ha mostrado un sostenido
            interés por la difusión de sus trabajos de
          </p>
          <p>
            &nbsp;investigación y actividades, a través de numerosas
            publicaciones realizadas por el gran
          </p>
          <p>
            &nbsp;Historiador e hijo de nuestra ciudad, Edgardo Mosca; siendo el
            eslabón fundamental en conectar la historia de los
          </p>
          <p>
            &nbsp;primeros pasos de Oliva con el despertar del interés de cada
            ciudadano en tener aferrados los conocimientos y recuerdos de
            nuestra esencia y sentido de pertenencia.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/3ED7q7x.png"
          alt="Cultura Oliva"
          className="historia-img-right"
          style={{ width: "280px" }}
        />
        <div>
          <p>
            El 17 de agosto de 1970, por iniciativa del Dr. Oscar René Chamale,
            en su momento Director de Cultura de la ciudad, se inaugura en la
            Biblioteca popular “Juventud Unida” la Exposición Permanente de
            Ciencias Naturales y del Hombre; siendo éste el puntapié inicial del
            Museo de la ciudad de Oliva, funcionando en ésta hasta 1979.
          </p>
          <p>
            En 1980, el municipio alquila el inmueble sobre calle Roque Saenz
            Peña a la flia Gastaldi, donde funcionó el Museo de Ciencias
            Naturales y del Hombre conjuntamente con los talleres culturales.
            Fue una época donde la Cultura tuvo un papel preponderante, con la
            participación activa de pintores, escultores, músicos,
            taxidermistas, coleccionistas y público de la ciudad que visitaba
            todos los domingos la muestra. En 1984 se realiza la primer
            Exposición de Oliva en el Obispo Mercadillo.
          </p>
          <p>
            En la década de 1990, la casa de la Cultura se traslada a la
            propiedad de calle San Lorenzo donde continúa el funcionamiento de
            algunos talleres y la preservación de piezas históricas. Con el paso
            del tiempo se transformó en un depósito donde muchas piezas
            sufrieron deterioro y debieron ser desechadas; otras retiradas por
            sus donantes debido a que ya no eran expuestas y muy pocas se
            mantuvieron correctamente.
          </p>
          <p>
            En 2010, por iniciativa del CENMA Oliva y con motivo de la
            celebración del Bicentenario de la Revolución de Mayo, recuperan y
            restauran estos objetos para exhibirlos en un Espacio Museológico en
            el marco de un proyecto institucional. Una vez finalizada esta
            muestra, los objetos vuelven a la Dirección de Cultura donde fueron
            preservados hasta la actualidad.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/kspECZG.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            Hoy; con los recursos que la tecnología nos brinda y ante la
            dificultad de mostrar nuestro patrimonio histórico en un espacio
            físico adecuado, tenemos la posibilidad de desarrollar el Museo de
            Oliva Virtual, un escenario dinámico y abarcativo, donde todos
            aquellos interesados en resguardar las piezas históricas de la
            ciudad logran tener un acceso directo y libre.
          </p>
          <p>
            El Museo de Oliva Virtual es un espacio emergente de la Dirección de
            Desarrollo Cultural, Educativo y Deportivo de la Municipalidad de
            Oliva que permite visibilizar el paso del tiempo en la ciudad,
            poniendo foco de atención sobre nuestro patrimonio (personalidades,
            acontecimientos u objetos) que irrumpió en un tiempo determinado de
            la historia de nuestra comunidad.
          </p>
          <p>
            El objetivo principal es poder reemplazar a través de la modalidad
            digital, el museo tradicional debido a que actualmente Oliva no
            cuenta con un espacio físico adecuado para preservar las piezas
            históricas de la ciudad. El Museo en red tiene un especial atractivo
            ya que ofrece el acceso colectivo a valores locales con una carga
            histórica y emotiva muy importante. Un acceso gratuito y un
            acercamiento a las nuevas generaciones y actores principales de la
            era digital, en el intento de resguardar la memoria de Oliva por
            muchos años más. Además de trascender las limitaciones de espacio y
            tiempo que posee un museo físico, el MOVI hace posible la
            organización simultánea según distintos criterios, contextos y posee
            además el potencial de reconceptualizar la relación entre los
            elementos expuestos y sus visitantes, siendo más directo,
            participativo y democrático.
          </p>
          <p>
            La comunidad en general puede ser parte de esta intervención
            cultural aportando elementos arraigados en la historia de cada
            persona, familia o empresa que han sabido sobrevivir al paso del
            tiempo. La posibilidad de conservar elementos de nuestro pasado nos
            permite escribir una nueva estrofa hacia el futuro.
          </p>
          <p>
            Si se habla de cultura en Oliva, no se debe dejar de citar al
            Movimiento Cultural Región del Manco Paz con una trayectoria notable
            y distinguida desde 1986, presidido por Nelly Bonetto de Aimar, una
            abanderada de nuestra cultura en la ciudad desde hace muchos años
            junto con otros pintores han mantenido el bastión de fomentar el
            arte a través de sus expresiones tales como la creación de la
            Agrupación de Pintores de Oliva, acompañando a Nelly se encontraban:
            René O. Chamale, Elba Picca, Miguel Pignatelli, Elda de Burdino,
            Irene O. de Gallará, Raquel S. de Ré, Hermette Martolio, Violeta
            Vázquez, Claudio Prenna, Iris Ré y Juan B. Cavigliasso. De las
            iniciativas logradas incansablemente desde hace más de 30 años el
            objetivo en común ha sido exhibir y contagiar a profesionales y
            aficionados del arte a sumarse, expandiendo talentos cada vez que se
            da la oportunidad en innumerables lugares, participaciones y
            anécdotas para citar en cada una de ellas.
          </p>
          <p>
            Ya acercándonos a nuestros días, se destaca la creación del Himno de
            la ciudad de Oliva en 2010, a cargo de Daniel Scaramuzza y del poeta
            Mansueto Córdoba, describiendo la historia olivense en estrofas que
            inundan cada acto celebrado en la ciudad. En este mismo año también,
            mediante concurso se crea la bandera de la ciudad, siendo el creador
            el Sr. José Devalis, un joven estudiante secundario destacado entre
            muchos otros participantes. Con este logro se fortalece el sentido
            de pertenencia y la identificación de la localidad, teniendo nuestra
            música, nuestra bandera y nuestro escudo.
          </p>
          <p>
            En 1918 se crea la primer Banda de Música, perteneciente al Hospital
            Dr. Emilio Vidal Abal; en ese tiempo llamado Asilo Colonia Regional
            Mixto de Alienados de Oliva, con la conducción del Maestro
            Bernardino Lépori. En 1977 el Cuerpo de Bomberos Voluntarios de
            Oliva pone de manifiesto que el Sr. Carlos Marchisio sería quien
            tendría la tarea de la creación de la banda. Pasados los años, más
            precisamente en 1979, toma vigencia la Banda de Música del Cuerpo de
            Bomberos Voluntarios de Oliva, compuesta por jóvenes, mixta; y con
            la presencia además de niños y adultos; bajo la Dirección de Enrique
            Alonso. También ese año se crea el Coro Polifónico, dirigido por
            Leonardo Nola.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/nUHhYQf.png"
          alt="Cultura Oliva"
          className="historia-img-right"
          style={{ width: "180px" }}
        />
        <div>
          <p>
            35 años más tarde; luego de no poder recomponer el grupo armado de
            músicos representativos; un 1º de abril de 2017 se reúne por fin, en
            la Noche de Vela la Banda de Música del Museo Nacional de Malvinas
            que lleva el nombre de su primer Director Enrique Vicente Alonso,
            bajo la dirección de Eduardo Navarro. Además de ello, el MUNAM y la
            Municipalidad de Oliva, crearon de manera conjunta la Escuela y
            Conservatorio de Música que lleva el nombre de Eduardo Navarro en
            reconocimiento a su trayectoria como maestro músico y que será
            dirigido por los profesores: Gabriel Ríos , José Luis Garnero y
            Sandra Bernardi. Desde ese 1º de abril, la Banda de Música del Museo
            Nacional de Malvinas “Enrique Vicente Alonso” dice presente en cada
            evento, acto y Festival de Oliva incluso participando en
            invitaciones de ciudades vecinas con un destacado viaje para un
            homenaje histórico a Mendoza, poniendo de manifiesto el orgullo de
            pertenecer a tan prestigiosa Institución.
          </p>
          <p>
            Un ícono de la Cultura en la ciudad de Oliva, de la tradición y de
            las costumbres es la conformación de las Agrupaciones Gauchas,
            fieles custodios de la Fiesta Nacional de la Navidad Gaucha; se
            destaca la institución gaucha más longeva de la ciudad, el Centro
            Tradicionalista Corral de Pachi; con una riquísima historia a nivel
            nacional con participaciones en festivales de enorme envergadura,
            con una vigencia de más de 50 años representando nuestra ciudad y
            nuestras costumbres a lo largo y ancho del país. Las demás
            agrupaciones gauchas son más jóvenes pero de igual sentido de
            pertenencia y participación incesante en cada evento realizado en
            conjunto con la Municipalidad e incluso otras instituciones u
            organizaciones. Ellas son: Agrupación Gaucha José Hernández y
            Medalla Milagrosa; quienes además son organizadoras de la
            celebración del Día de la tradición con un desfile por la ciudad,
            ofrenda y sentidas palabras. Las agrupaciones gauchas denotan que
            las costumbres siguen intactas con el paso del tiempo en ciudades
            que progresan y cambian de sentido en cuanto al desarrollo y las
            generaciones quedando siempre presente el sentido de pertenencia
            criollo nacional.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/a56UH2N.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            Hoy; con los recursos que la tecnología nos brinda y ante la
            dificultad de mostrar nuestro patrimonio histórico en un espacio
            físico adecuado, tenemos la posibilidad de desarrollar el Museo de
            Oliva Virtual, un escenario dinámico y abarcativo, donde todos
            aquellos interesados en resguardar las piezas históricas de la
            ciudad logran tener un acceso directo y libre.
          </p>
          <p>
            El Museo de Oliva Virtual es un espacio emergente de la Dirección de
            Desarrollo Cultural, Educativo y Deportivo de la Municipalidad de
            Oliva que permite visibilizar el paso del tiempo en la ciudad,
            poniendo foco de atención sobre nuestro patrimonio (personalidades,
            acontecimientos u objetos) que irrumpió en un tiempo determinado de
            la historia de nuestra comunidad.
          </p>
          <p>
            El objetivo principal es poder reemplazar a través de la modalidad
            digital, el museo tradicional debido a que actualmente Oliva no
            cuenta con un espacio físico adecuado para preservar las piezas
            históricas de la ciudad. El Museo en red tiene un especial atractivo
            ya que ofrece el acceso colectivo a valores locales con una carga
            histórica y emotiva muy importante. Un acceso gratuito y un
            acercamiento a las nuevas generaciones y actores principales de la
            era digital, en el intento de resguardar la memoria de Oliva por
            muchos años más. Además de trascender las limitaciones de espacio y
            tiempo que posee un museo físico, el MOVI hace posible la
            organización simultánea según distintos criterios, contextos y posee
            además el potencial de reconceptualizar la relación entre los
            elementos expuestos y sus visitantes, siendo más directo,
            participativo y democrático.
          </p>
          <p>
            La comunidad en general puede ser parte de esta intervención
            cultural aportando elementos arraigados en la historia de cada
            persona, familia o empresa que han sabido sobrevivir al paso del
            tiempo. La posibilidad de conservar elementos de nuestro pasado nos
            permite escribir una nueva estrofa hacia el futuro.
          </p>
          <p>
            Si se habla de cultura en Oliva, no se debe dejar de citar al
            Movimiento Cultural Región del Manco Paz con una trayectoria notable
            y distinguida desde 1986, presidido por Nelly Bonetto de Aimar, una
            abanderada de nuestra cultura en la ciudad desde hace muchos años
            junto con otros pintores han mantenido el bastión de fomentar el
            arte a través de sus expresiones tales como la creación de la
            Agrupación de Pintores de Oliva, acompañando a Nelly se encontraban:
            René O. Chamale, Elba Picca, Miguel Pignatelli, Elda de Burdino,
            Irene O. de Gallará, Raquel S. de Ré, Hermette Martolio, Violeta
            Vázquez, Claudio Prenna, Iris Ré y Juan B. Cavigliasso. De las
            iniciativas logradas incansablemente desde hace más de 30 años el
            objetivo en común ha sido exhibir y contagiar a profesionales y
            aficionados del arte a sumarse, expandiendo talentos cada vez que se
            da la oportunidad en innumerables lugares, participaciones y
            anécdotas para citar en cada una de ellas.
          </p>
          <p>
            Ya acercándonos a nuestros días, se destaca la creación del Himno de
            la ciudad de Oliva en 2010, a cargo de Daniel Scaramuzza y del poeta
            Mansueto Córdoba, describiendo la historia olivense en estrofas que
            inundan cada acto celebrado en la ciudad. En este mismo año también,
            mediante concurso se crea la bandera de la ciudad, siendo el creador
            el Sr. José Devalis, un joven estudiante secundario destacado entre
            muchos otros participantes. Con este logro se fortalece el sentido
            de pertenencia y la identificación de la localidad, teniendo nuestra
            música, nuestra bandera y nuestro escudo.
          </p>
          <p>
            En 1918 se crea la primer Banda de Música, perteneciente al Hospital
            Dr. Emilio Vidal Abal; en ese tiempo llamado Asilo Colonia Regional
            Mixto de Alienados de Oliva, con la conducción del Maestro
            Bernardino Lépori. En 1977 el Cuerpo de Bomberos Voluntarios de
            Oliva pone de manifiesto que el Sr. Carlos Marchisio sería quien
            tendría la tarea de la creación de la banda. Pasados los años, más
            precisamente en 1979, toma vigencia la Banda de Música del Cuerpo de
            Bomberos Voluntarios de Oliva, compuesta por jóvenes, mixta; y con
            la presencia además de niños y adultos; bajo la Dirección de Enrique
            Alonso. También ese año se crea el Coro Polifónico, dirigido por
            Leonardo Nola.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/nUHhYQf.png"
          alt="Cultura Oliva"
          className="historia-img-right"
        />
        <div>
          <p>
            35 años más tarde; luego de no poder recomponer el grupo armado de
            músicos representativos; un 1º de abril de 2017 se reúne por fin, en
            la Noche de Vela la Banda de Música del Museo Nacional de Malvinas
            que lleva el nombre de su primer Director Enrique Vicente Alonso,
            bajo la dirección de Eduardo Navarro. Además de ello, el MUNAM y la
            Municipalidad de Oliva, crearon de manera conjunta la Escuela y
            Conservatorio de Música que lleva el nombre de Eduardo Navarro en
            reconocimiento a su trayectoria como maestro músico y que será
            dirigido por los profesores: Gabriel Ríos , José Luis Garnero y
            Sandra Bernardi. Desde ese 1º de abril, la Banda de Música del Museo
            Nacional de Malvinas “Enrique Vicente Alonso” dice presente en cada
            evento, acto y Festival de Oliva incluso participando en
            invitaciones de ciudades vecinas con un destacado viaje para un
            homenaje histórico a Mendoza, poniendo de manifiesto el orgullo de
            pertenecer a tan prestigiosa Institución.
          </p>
          <p>
            Un ícono de la Cultura en la ciudad de Oliva, de la tradición y de
            las costumbres es la conformación de las Agrupaciones Gauchas,
            fieles custodios de la Fiesta Nacional de la Navidad Gaucha; se
            destaca la institución gaucha más longeva de la ciudad, el Centro
            Tradicionalista Corral de Pachi; con una riquísima historia a nivel
            nacional con participaciones en festivales de enorme envergadura,
            con una vigencia de más de 50 años representando nuestra ciudad y
            nuestras costumbres a lo largo y ancho del país. Las demás
            agrupaciones gauchas son más jóvenes pero de igual sentido de
            pertenencia y participación incesante en cada evento realizado en
            conjunto con la Municipalidad e incluso otras instituciones u
            organizaciones. Ellas son: Agrupación Gaucha José Hernández y
            Medalla Milagrosa; quienes además son organizadoras de la
            celebración del Día de la tradición con un desfile por la ciudad,
            ofrenda y sentidas palabras. Las agrupaciones gauchas denotan que
            las costumbres siguen intactas con el paso del tiempo en ciudades
            que progresan y cambian de sentido en cuanto al desarrollo y las
            generaciones quedando siempre presente el sentido de pertenencia
            criollo nacional.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/a56UH2N.png"
          alt="Cultura Oliva"
          className="historia-img-left"
        />
        <div>
          <p>
            Una de las celebraciones más significativas que ha tomado impulso y
            la colaboración de muchas de las instituciones que se animan a esta
            faceta culinaria es la “Fiesta de Colectividades” en la que se
            brinda un espectáculo artístico variado en cuanto a géneros, danzas
            y la cuota de humor; un extenso y nutrido paseo de artesanías y la
            vedette del evento es obviamente las comidas típicas elaboradas por
            los mismos integrantes de las Instituciones que dicen presente;
            manteniendo las tradiciones de los países que representan. Esta
            esencia es digna de destacar porque la comunidad participa de manera
            constante, y tomando ya una dimensión que genera la atracción del
            público de otras localidades que se llegan a celebrarlo junto con
            los olivenses.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <img
          src="https://i.imgur.com/sHogXuS.png"
          alt="Cultura Oliva"
          className="historia-img-right"
        />
        <div>
          <p>
            Cada 2 de abril, luego del acto oficial celebrado por los olivenses
            e invitados especiales incluso vecinos de otros municipios que se
            llegan a recordar esta fecha tan sentida; se organiza un evento
            deportivo en homenaje a quienes han defendido la patria de manera
            extrema; con mucho sentimiento se realiza la “Maratón Héroes de
            Malvinas”, con mucho respeto y admiración a quienes participan,
            poniendo un manto de sonrisa y vida sana para descomprimir la
            jornada conmovedora que envuelve al pueblo malvinero.
          </p>
        </div>
      </div>
      <div className="historia-section">
        <h2 className="historia-subtitle">
          Personalidades destacadas de la cultura y el arte de Oliva
        </h2>
        <p>
          En cuanto a la cultura y arte expresada por personalidades destacadas
          de la localidad se encuentran:
        </p>
        <ul>
          <li>
            <strong>María Teresa Andruetto:</strong> Escritora, oriunda de
            Arroyo Cabral, con infancia en nuestra ciudad; premiada y reconocida
            a nivel nacional e internacional por obras literarias de excelencia
            para niños y jóvenes; poesías, teatro, entre otros trabajos
            realizados. También ha referido sus obras a la identidad individual
            y social, dictadura y al universo femenino. Fundadora del Centro de
            Difusión e Investigación de Literatura Infantil y Juvenil (CEDILIJ).
            Codirige la colección Narradoras Argentinas en la Editorial
            Universitaria de Villa María (EDUVIM).
          </li>
          <li>
            <strong>Pablo Salvador Rocha:</strong> Jóven Escultor contemporáneo,
            reconocido a nivel nacional e internacional con obras figurativas de
            celebridades como Cortázar y Borges; así como también especies
            animales y homenajes como a Héroes de Malvinas; con piezas metálicas
            que han viajado a distintos puntos del mundo exponiendo su arte.
          </li>
          <li>
            <strong>Jorge Cuello:</strong> Muralista olivense, radicado en Las
            Rosas, Valle de traslasierra; fundador de diversos Museos de Arte
            como el Comebiróm, Galería de Arte Praxis. Un autodidacta con
            influencias reconocibles; formado en sus viajes de estudio mediante
            riesgos y experimentación; más allá del talento nato ineludible e
            indiscutible. De exposiciones importantes como el Museo Caraffa,
            Salón de Pintura Pro-Arte Córdoba; también realizó obras
            incursionadas en historietas para Teatros y espectáculos, revistas
            como La Luciérnaga. Los murales más importantes han sido en el
            Pabellón Argentina de Ciudad Universitaria, Museo de los niños
            “Barrilete”, Centro Cultural España-Córdoba, Cine Club Municipal
            Hugo del Carril y el Pueblo Luciérnaga entre otros. Sus últimas
            obras en el Museo Nacional de Bellas Artes, El juicio final (muestra
            callejera) y Jamón del medio (mural realizado en 86 cajas de pizza y
            tiza pastel).
          </li>
          <li>
            <strong>Cura Enrique Visca Caviglia:</strong> El 13 de marzo de
            1912, llega procedente de la parroquia de Villa del Rosario, de la
            cual fue teniente cura, el Presbítero Enrique Visca Caviglia para
            hacerse cargo de la flamante parroquia con el grado de Cura Párroco
            según designación del Obispo de Córdoba Monseñor Dr. Zenón Bustos y
            Ferreyra. De esta manera era reemplazado el padre Colabianchi de la
            parroquia de Villa María que solía llegar hasta Oliva una vez al
            mes.
            <ul>
              <li>
                El 13 de marzo de 1912 es nombrado primer Cura Párroco de la
                Parroquia Sagrado Corazón.
              </li>
              <li>
                Este mismo año, un 30 de marzo, funda el colegio Primario
                Sagrado Corazón.
              </li>
              <li>En 1924 funda la revista quincenal “Verdad y Acción”</li>
              <li>
                El 31 de diciembre de 1926 funda el Círculo Católico Obrero.
              </li>
              <li>
                En 1933, un 5 de marzo, funda el Colegio Catalina Caviglia de
                Visca, en nivel primario y en 1940 el nivel secundario.
              </li>
              <li>
                El 29 de marzo de 1948 funda el Instituto Secundario Sagrado
                Corazón.
              </li>
            </ul>
            En el año 1960, luego de 48 años de función como Párroco, se retira
            con el afecto del pueblo y el reconocimiento de toda una familia
            católica. El 8 de julio de 1967, deja de existir en la ciudad de
            Córdoba capital.
          </li>
          <li>
            <strong>Adriana Gatti:</strong> Olivense, radicada en Santa Rosa de
            Calamuchita; artista plástica abocada a la joyería contemporánea,
            obras de seda intervenida con textos bordados e imágenes. Realiza
            clínicas de arte y exposiciones en todo el país y en otros países
            como Holanda, México y Brasil.
          </li>
          <li>
            <strong>Luis Acosta:</strong> Artista plástico nacido en Oliva,
            radicado actualmente en Holanda; artista textil que luego se
            incursionó en el papel, donde sus obras han sido expuestas en muchos
            países de Europa y América.
          </li>
          <li>
            <strong>Mario Rodríguez:</strong> Músico olivense, de destacada
            trayectoria a nivel nacional. Comenzó sus estudios a los 7 años en
            la Banda Infanto Juvenil de Oliva en 1981; luego tomo clases en
            Córdoba con el maestro Marcelo Conca y Gustavo Cocha. En Buenos
            Aires se perfeccionó en su instrumento más conocido; la trompeta.
            Integró bandas de Jazz en Estados unidos con Mike Rodriguez. Ha
            realizado tareas docentes en Institutos Terciarios como “La Metro” y
            en la Escuela Superior de Música de Colonia Caroya y Villa General
            Belgrano. Ha sido parte de distintos proyectos musicales de
            diferentes géneros tales como Cuarteto (Pelusa, La Fiesta y
            Sebastián), Orquesta Metropolitana de Córdoba en el Festival de
            Tango de la Falda; Jazz en Bolivia (La Paz Big Band) y actualmente
            su calidad de trompetista se ha posado sobre las tablas, integrando
            el Staff de Ángel Carabajal, en América Show y Haydée.
          </li>
          <li>
            <strong>Pipo Valle:</strong> Poeta nacido en Oliva, radicado y ya
            fallecido en Santa Fe. Es el creador del segundo Himno de la ciudad.
          </li>
          <li>
            <strong>Betina Chamale:</strong> Profesional de la salud,
            violinista; miembro de la Orquesta de Cuerdas de la Municipalidad de
            Córdoba y de la Orquesta Sinfónica de Córdoba.
          </li>
          <li>
            <strong>Gabriel Alfonso Baldi:</strong> Artista plástico olivense,
            reconocido por sus intervenciones con acuarelas, óleos y tintas.
          </li>
          <li>
            <strong>Gustavo Márquez:</strong> Artista restaurador renacentista
            de bienes culturales nacido en Oliva, con una extensa carrera en
            Madrid, España; entre los trabajos que se destacan se puede nombrar:
            Restaurador de la Iglesia Santos, del edificio de la Cruz Roja, en
            el Palacio Real y para la Reina Leticia de España. Además realizó
            trabajos para la boca del actual Rey Felipe VI, las fuentes de la
            Realeza de Aranjuez y en catedrales de la Rioja, Toledo, Burgos,
            Castilla, La Mancha, Extremadura y el Castillo de León.
          </li>
          <li>
            <strong>Ricardo Wado Ferreyra:</strong> Cantante Folklórico;
            olivense situado actualmente en la provincia de Jujuy. De notable
            trayectoria, consiguiendo logros desde niño como la Revelación del
            Festival Nacional de Doma y Folklore de Jesús María en 2010.
          </li>
          <li>
            <strong>The Cover´s Cumbia:</strong> Grupo de jóvenes de la ciudad
            de cumbia canchera, con participantes de otras localidades; con
            espectáculos dados en la provincia, y algunas provincias como Buenos
            Aires, San Luis y La Rioja; hasta llegar a ser animadores de viajes
            de estudio en Camboriú Brasil. Con varias temporadas de verano
            realizadas en Villa Carlos Paz.
          </li>
          <li>
            <strong>Eduardo Cavigliaso:</strong> Músico olivense, compositor de
            más de 250 temas musicales. Nacido en 1915; en 1944 ingresó a la
            Orquesta de Lorenzo Barbero y en 1947 formó su propia orquesta de
            tango. Como anécdota y dato de color se destaca que ha sido el
            creador del primer Himno de Oliva. Destacado Ciudadano Ilustre de la
            Provincia de Córdoba, Medalla de Oro de SADAIC, socio honorífico de
            la Federación Cordobesa de Tango, Premio José Luis de Cabrera, entre
            otros reconocimientos. Entre los temas musicales más distinguidos de
            quien ha sido miembro de la época dorada de las orquestas típicas de
            tango se puede citar: “Juventud del 40´”,”Canto a Miramar”, entre
            otros éxitos.
          </li>
          <li>
            <strong>Carlos “Tuta” García:</strong> Músico-Locutor y miembro de
            grupos de cuarteto tales como La Barra y fundador del grupo Sabroso
            a partir de 2001. Con menciones especiales en diversos puntos del
            país.
          </li>
          <li>
            <strong>José Luis “Pepe” Garnero:</strong> Músico, compositor:
            colaborador y miembro de bandas de cuarteto tales como Chébere,
            Banda Express, entre otros grupos; así como también realizó arreglos
            para melodías de otros géneros musicales. De una trayectoria enorme,
            reconocida en el mundo del cuarteto cordobés.
          </li>
          <li>
            <strong>Estanislao Esteban Karlic, “Monseñor Karlic”:</strong>{" "}
            Olivense nacido en febrero de 1926, Obispo argentino, Cardenal de la
            Iglesia Católica. Se desempeñó como Arzobispo de Paraná, Entre Ríos
            (radicado actualmente allí) desde 1986 hasta 2003 y fue elevado a
            Cardenalato en 2007.
            <br />
            Estudió en el Seminario Mayor de Córdoba, y en la Universidad
            Pontificia Gregoriana de Roma, donde obtuvo un doctorado en
            teología. Después de su ordenación sacerdotal el 8 de diciembre de
            1954, Karlic se desempeñó como superior de la sección de filosofía
            del Seminario Mayor de Córdoba, donde también fue profesor de
            teología.
            <br />
            El 6 de junio de 1977, Karlic fue nombrado obispo titular de Castrum
            por el papa Pablo VI. Recibió su consagración episcopal el 15 de
            agosto siguiente del cardenal Raúl Francisco Primatesta, con los
            obispos Alfredo Disandro y Cándido Rubiolo como coconsagrantes.
            Karlic más tarde fue nombrado arzobispo coadjutor y administrador
            apostólico de la arquidiócesis de Paraná el 19 de enero de 1983,
            para finalmente suceder en el puesto a su Arzobispo el 1 de abril de
            1986. De 1986 a 1992, fue miembro de la comisión para la redacción
            del nuevo Catecismo de la Iglesia católica. En 1999, Karlic llamó a
            la unidad entre los pueblos del Hemisferio Occidental y para el
            respeto de las culturas de las pequeñas naciones. Se desempeñó como
            presidente de la Conferencia Episcopal Argentina durante dos
            períodos consecutivos (1996- 1999, 1999-2002) antes de dimitir como
            arzobispo de Paraná el 29 de abril de 2003, después de siete años de
            servicio.
            <br />
            El papa Benedicto XVI lo creó cardenal presbítero del Título de
            Nuestra Señora de los Dolores en la plaza de Buenos Aires, en el
            consistorio del 24 de noviembre de 2007. Como cuenta con más de 80
            años en el momento de su elevación, Karlic no puede participar en un
            cónclave papal.
            <br />
            El 11 de octubre de 2013, la Universidad Católica de Santa Fe le
            otorgó el grado académico de doctor honoris causa, en una ceremonia
            presidida por José María Arancedo, presidente de la Conferencia
            Episcopal Argentina.
          </li>
          <li>
            <strong>Mención especial a Josefina Musso y Emmanuel Aimar:</strong>{" "}
            En la actualidad son dos artistas que nos representan en todo el
            país y que han sido dos espectáculos exitosos de la temporada en
            Villa Carlos Paz. Josefina comparte escenario y obra con el olivense
            Mario Rodriguez, siendo su quinta aparición en las tablas de la
            Compañía Sentires (en la cuarta aparición fue ternada a los Premios
            Carlos como “mejor bailarina” representando a Bien Argentino); en
            este caso para “América Show” cumpliendo objetivos y con la
            satisfacción de haber sido la obra más premiada de la temporada. En
            cuanto a Emmanuel, se ha distinguido su voz en la obra “Humor
            Indispensable” junto a Mario Fassi y Marcelo Josset; el año pasado
            fue ternado y ganador por la obra “Bien Argentino” como “mejores
            músicos en vivo”.
          </li>
        </ul>
      </div>
      <div className="historia-section">
        <h2 className="historia-subtitle">Festivales y Eventos Culturales</h2>
        <ul>
          <li>
            <strong>“Una ventana abierta a la cultura”</strong> enmarcada en la
            Semana de la Cultura: Organizada desde hace 20 años por el colegio
            secundario IPEM Nº 289 “Dr. Ramón Picco” en el mes de octubre; de la
            que a principios de este evento se realizaba internamente en la
            institución; con el correr de los años se fue abriendo camino a la
            participación de colegios de la ciudad y en las últimas
            presentaciones se ha dado participación a colegios de otras
            localidades. La participación de la totalidad del alumnado, sumado a
            la de profesores y padres que colaboran en la preparación de la
            presentación y el eje temático asignado para la puesta en escena de
            la semana cultural que se empieza a sentir y visibilizar meses antes
            del día inicial; la ciudad se ve distinta, se transforma a medida
            que se va acercando la fecha y va tomando color. La Semana de la
            Cultura ha tomado relevancia de nivel provincial recibiendo por
            parte del Ministerio de Educación de la Provincia la distinción de
            que “Una ventana abierta a la cultura” fue declarada “De interés
            educativo” además de haber sido declarada “De interés municipal” por
            el Concejo Deliberante de la ciudad.
          </li>
          <li>
            <strong>72 hs de arte:</strong> Organizada desde hace 5 años por el
            IPEM Nº 72 “Juventud Unida” en el mes de septiembre; tomando la
            posta del incentivo de su orientación en arte y arte visual, en
            crecimiento, de proponerle a la comunidad de Oliva las alternativas
            artísticas en distintos ámbitos, a alumnos de la institución y a los
            de otros establecimientos educativos, incluso al público en general;
            como tapicería, pintura, teatro, técnicas de respiración, locución y
            radio teatro, talleres literarios y de cocina, danzas, entre algunas
            de las múltiples opciones disponibles. Dicho proyecto integrador
            puesto a disposición de quien quiera hacer uso y goce crece año tras
            año de manera exponencial dejando un mensaje de convivencia, de
            trabajo en equipo, de superación y de que el arte es importante para
            mejorar la calidad de vida de las personas. Cabe destacar que esta
            institución también celebra la “Semana de la Familia” en el mes de
            noviembre con interesantes actividades que hacen a crear un
            excelente clima para distender de las situaciones cotidianas que
            vivimos; poniendo un poco de buena intención y que el nexo Colegio –
            Alumno – Familia sea homogéneo.
          </li>
          <li>
            <strong>La Feria del Libro</strong> organizada por el Centro
            Educativo Bartolomé Mitre es un clásico evento propuesto desde el
            año 2006 a la comunidad de manera gratuita, con diversas
            alternativas de participación. Bajo el lema “Yo leo, tu lees… todos
            leemos” se trata de incentivar a quien desee participar a la
            curiosidad, a despertar el interés por la comprensión de los textos
            tanto para niños, jóvenes y adultos siendo un recurso sano e
            importante para la salud mental y contribuye a engrosar la calidad
            cultural de la ciudad. Entre las actividades que se realizan se
            encuentran: Cortometrajes, narradores, espectáculos infantiles,
            presentaciones de libros, haremos reconocimientos a personalidades
            de Oliva y la zona, muestra de trabajos de los alumnos durante el
            año entre otras opciones. Declarado de “Interés Municipal” en 2008.
          </li>
          <li>
            <strong>Encuentro de la Música:</strong> El evento es organizado por
            la Escuela Especial Rosa Silvia Nocetti que, con más de 20 años de
            antigüedad, es una de las actividades educativas y artísticas más
            convocantes y con mucha llegada a la comunidad. Aquí se pone de
            manifiesto el objetivo fundamental que es la inclusión social y el
            desarrollo artístico y musical tanto de los alumnos como de quienes
            se encuentren afectados directa e indirectamente al evento. El
            Encuentro tiende a expandir sus alas de alcance ya que es una
            oportunidad de expresarse tal como su lema lo presenta: “Expresiones
            de libertad”. Las actividades que se realizan son las siguientes:
            talleres musicales, intervenciones urbanas, espectáculos en vivo y
            la participación de los alumnos exponiendo sus trabajos de todo el
            año.
          </li>
          <li>
            <strong>Semana de la Educación Técnica,</strong> organizada y
            celebrada por el IPET Nº 143 “Gral. José María Paz” en conmemoración
            al Día Nacional de la Educación Técnica el 15 de noviembre. Esta
            semana consta de actividades como: Presentaciones o exposiciones de
            ciencias naturales y sociales, comunicación, experiencias narradas
            por especialistas y el cierre con la caravana clásica integrada por
            alumnos, profesores y directivos, amigos y empresas acompañantes.
            Declarada de “Interés Municipal” en el año 2014.
          </li>
          <li>
            <strong>Semana del Estudiante, Fiesta de las Carrozas;</strong>{" "}
            Organizado por el Instituto Sagrado Corazón. Las actividades son
            similares en todos los colegios celebrando la llegada de la
            primavera y el día del estudiante, motivando a los estudiantes a
            celebrar la vida en una semana distendida, trabajando y aprendiendo
            valores, exponiendo toda su creatividad y frescura; lo destacable de
            este colegio es la organización de la Fiesta de las Carrozas; tantas
            veces coordinadas en tiempos lejanos por el Club Vélez Sarsfield
            para el carnaval; cada curso tiene un objetivo asignado sobre un
            tema en común para todos los cursos; la noche del desfile se elige a
            la mejor carroza entre los premios destacados junto con la elección
            del Rey y la Reina de los estudiantes en la que participan todos/as
            los/as soberanos/as de los demás colegios. Es un atractivo realmente
            muy lindo, colorido y con mucha concurrencia de vecinos de la
            ciudad.
          </li>
          <li>
            <strong>La Exposición “Cultura, Tradición y Progreso”,</strong>{" "}
            organizada por la Sociedad Rural de Oliva; de más de 40 años de
            vigencia, es la exposición más grande de la ciudad; con la
            participación de localidades vecinas, comercios y empresas de la
            zona, con una diversidad de rubros interesante y la propuesta de
            capacitaciones, charlas educativas y comerciales para aprender y
            aplicar en tiempos en donde los recursos humanos y tecnológicos son
            gran parte del éxito de un negocio; también se realizan
            apreciaciones para el sector agrícola-ganadero en cuanto a la
            economía y al clima y con respecto al plano social, se presentan
            profesionales para hablar sobre la niñez y adolescencia,
            equinoterapia. Para distender se ofrecen cenas y almuerzos
            empresariales a clientes y amigos, y la puesta en escena de
            desfiles, shows musicales y encuentros deportivos entre otros.
            Declarada de “Interés Municipal” en 2013.
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default Historia;
